export default {
  GET_SECTION_DETAIL_LIST: {
    url: '/section-detail/public/list',
    method: 'GET'
  },
  GET_TABLE_HEADING_LIST: {
    url: '/heading-table/public/list',
    method: 'GET'
  },
  UPDATE_SECTION_DETAIL: {
    url: '/section-detail',
    method: 'PUT'
  },
  UPDATE_TABLE_HEADING: {
    url: '/heading-table/update',
    method: 'PUT'
  },
  GET_TAB_PAGE_TITLE: {
    url: '/page-title/public/get-detail',
    method: 'GET'
  },
  UPDATE_TAB_PAGE_TITLE: {
    url: '/page-title/update',
    method: 'PUT'
  },
  UPDATE_ALL_TABLE_HEADINGS: {
    url: '/heading-table/update-all',
    method: 'PUT'
  },
  UPDATE_ALL_SECTION_DETAILS: {
    url: '/section-detail/update-all',
    method: 'PUT'
  },
  INDEX_ALL_DATA_TO_ELASTICSEARCH: {
    url: '/data-record/index-all-data-to-elasticsearch',
    method: 'PUT'
  },
  UPDATE_ALL_PREVIEW: {
    url: '/company/update-all-preview',
    method: 'PUT'
  },
  UPDATE_TERM_PREVIEW: {
    url: '/company/update-terms-preview',
    method: 'PUT'
  },
  UPDATE_PAGE_TITLE_PREVIEW: {
    url: '/company/update-page-title-preview',
    method: 'PUT'
  },
  UPDATE_TAB_TITLE_PREVIEW: {
    url: '/page-title/update-page-title',
    method: 'PUT'
  },
  UPDATE_HEADING_TABLE_PREVIEW: {
    url: '/heading-table/update-heading-table',
    method: 'PUT'
  },
  UPDATE_SECTION_DETAIL_PREVIEW: {
    url: '/section-detail/update-section-detail',
    method: 'PUT'
  }
};
